const formatter = Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
});

/**
 * Format currency to GBP
 * @param subject
 */
export function formatCurrency(subject: number | string) {
  try {
    return formatter.format(subject as number);
  } catch (e) {
    console.error(e);
    return "N/A";
  }
}
